Styxie.Initializers.Global = {
  index: (data) => {
    Styxie.WLC = data
  }
}
